import { useTranslation } from 'react-i18next';
import { Card, CardContent, Text } from '@shared/ui';

const TYPOGRAPHY_STEPS = [
  { labelKey: 'uiLibrary.tokens.typography.display', className: 'font-heading text-4xl font-bold' },
  { labelKey: 'uiLibrary.tokens.typography.h1', className: 'font-heading text-3xl font-bold' },
  { labelKey: 'uiLibrary.tokens.typography.h2', className: 'font-heading text-2xl font-semibold' },
  { labelKey: 'uiLibrary.tokens.typography.h3', className: 'font-heading text-xl font-semibold' },
  { labelKey: 'uiLibrary.tokens.typography.body', className: 'text-base' },
  { labelKey: 'uiLibrary.tokens.typography.small', className: 'text-sm' },
];

export function TypographyScale() {
  const { t } = useTranslation();
  const translate = (key: string) => t(key as never) as string;

  return (
    <Card>
      <CardContent className="space-y-4 p-6">
        {TYPOGRAPHY_STEPS.map((step) => (
          <div key={step.labelKey}>
            <Text size="xs" color="muted">
              {translate(step.labelKey)}
            </Text>
            <Text as="div" className={step.className}>
              {t('uiLibrary.tokens.typography.sample')}
            </Text>
          </div>
        ))}
        <div>
          <Text size="xs" color="muted">
            {translate('uiLibrary.tokens.typography.emptyValue')}
          </Text>
          <Text as="div" size="sm" color="emptyValue">
            {translate('uiLibrary.tokens.typography.emptyValueSample')}
          </Text>
        </div>
      </CardContent>
    </Card>
  );
}
